import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';

import './style.scss';
import classNames from 'classnames';

interface StepBookingProps {
    currentStep: number
}

const steps = [
    { name: 'booking_bike.title.select_date_time', type: 0 },
    { type: 1 },
    { name: 'booking_bike.title.select_the_option', type: 0 },
    { type: 1 },
    { name: 'booking_bike.title.confirmation', type: 0 }
];
function getStepName(steps: any[], currentStep: number) {
    // Lấy mảng chỉ chứa những phần tử type=0 (các step thật sự)
    const realSteps = steps.filter(s => s.type === 0);
    // currentStep là 1-based, nên lấy index = currentStep-1
    return realSteps[currentStep - 1]?.name ?? null;
}

export default observer(function StepProgress({
    currentStep
}: StepBookingProps) {
    // hook
    const { t } = useTranslation();

    return (
        <div className='w-full'>
            <div className='flex items-center justify-between'>
                {steps.map((step, idx) => {
                    const done = step.type === 0 ? (idx / 2 + 1) <= currentStep - 1 : (idx % 2) < currentStep;
                    const active = idx / 2 + 1 === currentStep;
                    const doneLine = step.type === 1 && idx <= currentStep;

                    return (
                        <div key={idx} className={classNames('flex items-center relative', step.type === 1 && 'flex-1')}>
                            {/* Circle */}
                            {
                                step.type === 0 && (
                                    <div className={`relative z-10 text-[20px] flex items-center font-bold justify-center size-10 rounded-full border transition-colors duration-500
                                            ${done || active ? 'bg-primaryWeb border-primaryWeb text-white' : 'border-[#868686] text-[#868686]'}
                                        `}
                                    >
                                        {
                                            idx / 2 + 1
                                        }

                                        {/* Label */}

                                        {step.name && (
                                            <span
                                                className={`sm:block hidden font-medium absolute break-all text-center text-fs-mid14 sm:top-11 top-8 px-2 sm:w-[200px] w-[100px] transition-colors duration-500 
                                        ${done || active ? 'text-text' : 'text-border-input-2'}
                                    `}
                                            >
                                                {t(step?.name)}
                                            </span>
                                        )}
                                    </div>
                                )
                            }

                            {/* Line (chỉ render nếu không phải bước cuối) */}
                            {step.type === 1 && idx < steps.length - 1 && (
                                <div
                                    className={`h-[2px] flex-1 mx-4 transition-colors duration-500
                                ${doneLine ? 'bg-primaryWeb' : 'bg-border-input-2'}`}
                                />
                            )}
                        </div>
                    );
                })}

            </div>
            <div className='sm:hidden flex justify-center items-center mt-2.5 leading-[24px]'>

                {/* <p className='text-[#868686]'>
                    ステップ
                    {' '}
                    {currentStep}
                    /
                    {steps.filter(item => item.type === 0).length}
                </p> */}
                <p className='font-semibold'>{t(getStepName(steps, currentStep))}</p>
            </div>
        </div>
    );
});
